import { Documents } from "@stories/pages/Document/Documents";
import React from "react";

const DocumentsView = () => {
  return <Documents />;
};

export default DocumentsView;
